<template>
  <div>
    <div class="row" v-for="(room , index) in fieldsValues[id]" :key="index">
      <div class="col-11">
        <div class="row">
          <div class="col-4" v-for="[key, field] of Object.entries(fields)" :key="key">
            <component
              @input="handleInputValue($event, index, key)"
              :is="'tic' + field.component.charAt(0).toUpperCase() + field.component.slice(1)"
              :name="key+(index-1)"
              :required="true"
              :custom-input="false"
              :label="field.hasOwnProperty('label') ? field.label : 'formation.offline.rooms.'+key+'.label'"
              :placeholder="field.hasOwnProperty('placeholder') ? field.placeholder : $te('formation.offline.rooms.'+key+'.placeholder') ? 'formation.offline.rooms.'+key+'.placeholder' : ''"
              v-bind="field.params"
              :value="fieldsValues[id][index][key]">
            </component>
          </div>
        </div>
      </div>
      <div v-if="fieldsValues[id].length > 1" class="col-1 d-flex justify-content-center align-items-end">
        <span title="Supprimer" class="ml-auto btn orange-white" @click="delRoom(index)">
          <span><i class="fas fa-trash-alt p-1"></i></span>
        </span>
      </div>
    </div>
    <div v-if="fieldsValues[id].length < nbMaxRooms" class="row">
      <div class="col-12 d-flex justify-content-center align-items-end">
        <span title="Ajouter" class="addButton btn orange-white" @click="addRoom">
          <!--<span><i class="fas fa-plus p-1"></i></span>-->
          {{ $t('formation.offline.rooms.add') }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>

import ticTextInfo from '@/components/formation/offline/textInfo'
import ticText from '@/components/frontoffice/form/baseInput/text'
import ticSelect from '@/components/frontoffice/form/baseInput/selectBVue'
import ticCheckboxGroup from '@/components/frontoffice/form/baseInput/checkboxBVue'
import ticRadio from '@/components/frontoffice/form/baseInput/radioBVue'
import ticSingleRadio from '@/components/frontoffice/form/baseInput/singleRadioBVue'

import ticRooms from '@/components/formation/form/offline/rooms'

export default {
  components: {
    ticTextInfo,
    ticText,
    ticSelect,
    ticCheckboxGroup,
    ticRadio,
    ticSingleRadio,
    ticRooms
  },
  data () {
    return {
      fieldsValues: {}
    }
  },
  props: {
    value: {
      type: [Object, String]
    },
    fields: {
      type: Object
    },
    nbRooms: {
      type: Number,
      default: 1
    },
    id: {
      type: String
    },
    firstRequired: {
      type: Boolean,
      default: true
    },
    nbMaxRooms: {
      type: Number
    }
  },
  methods: {
    handleInputValue (value, room, id) {
      this.fieldsValues[this.id][room][id] = value
      this.$emit('input', this.fieldsValues)
    },
    addRoom () {
      this.setUpRoomFields(this.fieldsValues[this.id].length)
      this.$emit('input', this.fieldsValues)
    },
    delRoom (index) {
      this.fieldsValues[this.id].splice(index, 1)
      this.$emit('input', this.fieldsValues)
    },
    setUpRoomFields (room) {
      this.fieldsValues[this.id].push({})

      for (let [key, field] of Object.entries(this.fields)) {
        this.fieldsValues[this.id][room][key] = ''
      }
    }
  },
  created () {
    if (this.value != '') {
      this.fieldsValues = this.value
    } else {
      this.$set(this.fieldsValues, this.id, [])
      for (let room = 0; room < this.nbRooms; room++) {
        this.setUpRoomFields(room)
      }
    }
  }
}
</script>
<style lang="scss" scoped>

.addButton {
  width: 35%;
  margin-top: 25px;
}
.btn:hover {
  cursor: pointer;
}
.row {
  margin-top: 5px;
}

</style>
